import {Component, OnInit} from '@angular/core';
import {GpioState} from "../../../store/gpio/gpio.state";
import {BackendService} from "../../../services/backend";
import {LineController} from "../../../model";
import {concat, merge} from "rxjs";
import {AuthenticationState} from "../../../store/auth/auth.state";

@Component({
    selector: 'app-gpio',
    templateUrl: './gpio.component.html',
    styleUrls: ['./gpio.component.scss'],
    standalone: false
})
export class GpioComponent implements OnInit {
  constructor(public gpioState: GpioState,
              public backend: BackendService,
              private authState: AuthenticationState) {
  }

  line: LineController = {
    machineIsOn: false,
    lineIsOn: false,
    bucketIsInTheScanner: false,
    continue: false,
    eject: false,
    raiseAlarm: false,
    lightOn: false
  };

  lineSet(v: Partial<LineController>) {
    this.backend.setLine(v).subscribe(l => {
        this.line = l
      }
    )
  }

  gpioSet(id: number, value: boolean) {
    console.log(id, value)
    this.gpioState.setGpio(id, value)
  }

  ngOnInit(): void {
    let lineStatus$ = concat(
      this.backend.getLineStatus(),
      this.backend.getLineUpdates()
    );

    lineStatus$.subscribe(l => this.line = l)
  }
}
